document.addEventListener("DOMContentLoaded", function (event) {
	//for IE 9 to Edge 12
	svg4everybody({
		polyfill: true
	});
	var cdnvalue = $("#cdnInput").data("value");
	var fontRelativePath = $("#siteFontRelativePath").data("value");

    //console.log("Font path: " + fontRelativePath);
    //console.log("Font pro key: " + fontProKey);

	function ie_ver() {
		var iev = 0;
		var ieold = (/MSIE (\d+\.\d+);/.test(navigator.userAgent));
		var trident = !!navigator.userAgent.match(/Trident\/7.0/);
		var rv = navigator.userAgent.indexOf("rv:11.0");

		if (ieold) iev = new Number(RegExp.$1);
		if (navigator.appVersion.indexOf("MSIE 10") != -1) iev = 10;
		if (trident && rv != -1) iev = 11;

		if (iev === 10 || iev === 11)
			return "ie ie-" + iev;
		return "";
	}

	function edge() {
		var isEdge = (/Edge/.test(navigator.userAgent));

		if (isEdge)
			return "edge";
		return "";
	}

	window.addEventListener('touchstart', function onFirstTouch() {
		// we could use a class
		jQuery("html").addClass('touch');

		// or set some global variable
		window.USER_IS_TOUCHING = true;

		// we only need to know once that a human touched the screen, so we can stop listening now
		window.removeEventListener('touchstart', onFirstTouch, false);

		shvenergy.cookies.setCookie("isTouch", "true", 365);

	}, false);


	if (shvenergy.cookies.getCookie("isTouch") === "true") {
		jQuery("html").addClass("touch");
		window.USER_IS_TOUCHING = true;
	}

	jQuery("html").removeClass("no-js");
	jQuery("html").addClass(ie_ver());
	jQuery("html").addClass(edge());

	objectFitImages();

	$(document).on('scroll', () => {
		document.body.dataset.scrollY = window.scrollY;

		if (window.scrollY > 0) {
			document.body.dataset.minimizeStickyElements = true;
		}
		else {
			document.body.dataset.minimizeStickyElements = false;
		}
	});

	$(document).on('load', () => {
		document.body.dataset.scrollY = window.scrollY;
	});
});